// import React from 'react'
import Create_Project_Component from '../../components/More Page/Create_Project/Create_Project_Component'

const Create_Project = () => {
  return (
    <div className="w-full py-10 bg-[#F6F5ED] flex flex-col items-center sm:px-0 px-5">
        <Create_Project_Component/>
    </div>
  )
}

export default Create_Project